import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {registerLocaleData} from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import {HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {PoupexUtilModule} from './poupex-util/poupex-util.module';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {TemplateComponent} from './template/template.component';
import {TemplateSomenteCorpoComponent} from './template-somente-corpo/template-somente-corpo.component';

import {ToastModule} from 'primeng/toast';
import {DialogModule} from 'primeng/dialog';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {TooltipModule} from 'primeng/tooltip';
import {ButtonModule} from 'primeng/button';
import {NgxLoadingModule} from 'ngx-loading';
import {GtagModule} from 'angular-gtag';
import {environment} from '../environments/environment';
import {MessageService} from 'primeng/api';


registerLocaleData(localePt, 'pt', localePtExtra);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    TemplateComponent,
    TemplateSomenteCorpoComponent
  ],
  imports: [
    /* módulo principal do Angular que provê os recursos para aplicação web */
    BrowserModule,
    /* módulo que provê as mensagens do sistema */
    ToastModule,
    /* módulo de animações do angular */
    BrowserAnimationsModule,
    /* arquivo de rotas da aplicação */
    AppRoutingModule,
    /* módulo para comunicação http do angular */
    HttpClientModule,
    /* módulo para apresentação do loader na tela */
    NgxLoadingModule.forRoot({}),
    /* módulo de utilitários da poupex */
    PoupexUtilModule,
    DialogModule,
    BreadcrumbModule,
    TooltipModule,
    ButtonModule,
    GtagModule.forRoot({
      trackingId: environment.TRACKING_ID,
      trackPageviews: true
    })
    // JwtModule.forRoot(
    //   { config: {
    //       tokenGetter: AutenticacaoService.getToken,
    //       skipWhenExpired: false
    //     }
    //   }),
    /* Inclusão condicional do Módulo para mockar serviços http em tempo de desenvolvimento */
    // environment.production ? [] : HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, { delay: 1000, apiBase: '/'})
  ],
  providers: [
    MessageService,
    {
      provide: LOCALE_ID,
      useValue: 'pt'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
